/* @__PURE__ */import { datadogRum } from "@datadog/browser-rum";
import consola from "consola";
import { useAuthStore } from "@stores/auth";
import type { User } from "@/types/user";
import type { Site } from "@datadog/browser-core/src/domain/configuration";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const authStore = useAuthStore();

  const applicationId = config.public.DD_APPLICATION_ID ?? null;
  const clientToken = config.public.DD_CLIENT_TOKEN ?? null;
  const site = config.public.DD_SITE as Site ?? null;
  const version = config.public.DD_VERSION ?? null;
  const env = config.public.DD_ENV ?? null;
  const service = config.public.APP_ID ?? null;

  if (!applicationId || !clientToken || !site || !version || !env) {
    consola.warn("Datadog RUM initialization skipped due to missing environment variables.");
    if (!applicationId) /* @__PURE__ */ consola.info("Missing DD_APPLICATION_ID");
    if (!clientToken) /* @__PURE__ */ consola.info("Missing DD_CLIENT_TOKEN");
    if (!site) /* @__PURE__ */ consola.info("Missing DD_SITE");
    if (!version) /* @__PURE__ */ consola.info("Missing DD_VERSION");
    if (!env) /* @__PURE__ */ consola.info("Missing DD_ENV");
    return;
  }

  try {
    datadogRum.init({
      applicationId,
      clientToken,
      site,
      version,
      env,
      service,
      sessionSampleRate: Number(config.public.DD_SESSION_SAMPLE_RATE) ?? 100,
      // sessionReplaySampleRate: Number(config.public.DD_TRACE_SAMPLE_RATE) ?? 10, // Remover porque não temos rum premium.
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
      allowedTracingUrls: [
        // All backend API.
        (url) => url.includes(config.public.API_URL),

        // All frontend URLs.
        (url) => url.includes(window.location.hostname),
      ],
    });

    datadogRum.startSessionReplayRecording();
    /* @__PURE__ */ consola.success("Datadog RUM initialized successfully.");
  } catch (error) {
    /* @__PURE__ */ consola.error("Error initializing Datadog RUM:", error);
  }

  function setDataDogUser(user: User) {
    /* @__PURE__ */ console.log("Setting user:", user);
    datadogRum.setUser({
      id: user.id,
      email: user.email,
      name: user.name
    });
    /* @__PURE__ */ consola.info("Datadog RUM user set:", datadogRum.getUser());
    return datadogRum.getUser();
  }

  return {
    provide: {
      setDataDogUser: () => {
        console.log("Setting user:", authStore.user);
      }
    }
  };
});
